import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { Form, Formik, FormikErrors } from "formik";
import * as React from "react";
import ButtonGroup from "../../components/Buttons/ButtonGroup";
import EditButton from "../../components/Buttons/EditButton";
import ErrorMsg from "../../components/ErrorMsg";
import ProgressIndicator from "../../components/ProgressIndicator";
import strings from "../../config/localization";
import { useEditResourceMutation } from "../../services/appln";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@material-ui/icons/Edit";

interface FormData {
  name: string;
  desc: string;
}

interface Props {
  id: string;
  initialValues: any;
}

export default function EditResource(props: Props) {
  console.log("EditResource, props:", props);
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [editResource, editResourceParams] = useEditResourceMutation();

  const iv: FormData = {
    name: props.initialValues.name,
    desc: props.initialValues.desc,
  };

  console.log("EditResource, editResourceParams", editResourceParams);
  React.useEffect(() => {
    if (editResourceParams.isSuccess) {
      handleClose();
    }
  }, [editResourceParams]);

  return (
    <div>
      <IconButton color="secondary" onClick={handleClickOpen}>
        <EditIcon />
      </IconButton>
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">
          {strings.editResource}
        </DialogTitle>
        {editResourceParams.isError && (
          <ErrorMsg msg={strings.failedToEditResource} />
        )}
        {editResourceParams.isLoading && <ProgressIndicator />}
        <DialogContent>
          <Formik
            initialValues={iv}
            validate={(values) => {
              const errors: FormikErrors<FormData> = {};
              if (!values.name) {
                errors.name = strings.nameMandatory;
              }
              return errors;
            }}
            onSubmit={(values, { setSubmitting }) => {
              setSubmitting(false);
              editResource({ id: props.id, body: values });
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setFieldValue,
            }) => (
              <Form>
                <Box sx={{ flexGrow: 1 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        required
                        margin="normal"
                        id="name"
                        name="name"
                        label={strings.name}
                        value={values.name}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.name && Boolean(errors.name)}
                        helperText={touched.name && errors.name}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        margin="normal"
                        id="desc"
                        name="desc"
                        multiline
                        rows={3}
                        label={strings.desc}
                        value={values.desc}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.desc && Boolean(errors.desc)}
                        helperText={touched.desc && errors.desc}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <ButtonGroup>
                        <Button
                          variant="contained"
                          type="submit"
                          disabled={isSubmitting}
                        >
                          {strings.save}
                        </Button>
                        <Button variant="contained" onClick={handleClose}>
                          {strings.cancel}
                        </Button>
                      </ButtonGroup>
                    </Grid>
                  </Grid>
                </Box>
              </Form>
            )}
          </Formik>
        </DialogContent>
      </Dialog>
    </div>
  );
}
